<template>
  <div class="v-view table-view a-fadeIn" :style="{ height: span * 33.33 + '%' }">
    <div class="v-title">{{ title }}</div>

    <table class="tv-table">
      <thead class="tv-table-head" align="center">
        <tr>
          <th v-for="(item, index) in tableHead" :key="index">
            {{ item }}
          </th>
        </tr>
      </thead>

      <tbody v-if="tableList.length > 0" ref="table" class="tv-table-body" align="center">
        <tr v-for="item in tableList" :key="item.id">
          <td class="td-time">{{ item.time }}</td>
          <td class="td-addr">{{ item.addr }}</td>
          <td class="td-name">{{ item.name }}</td>
          <td class="td-type">
            <img src="../assets/images/icon_bangle.png" alt="#" />
            <span>{{ item.type }}</span>
          </td>
          <td v-if="item.status === '正常'" class="td-status td-status--normal">
            <img src="../assets/images/icon_normal.png" alt="#" />
            <span>正常</span>
          </td>
          <td v-else class="td-status td-status--alarm">
            <img src="../assets/images/icon_alarm.png" alt="#" />
            <span>报警</span>
          </td>
        </tr>
      </tbody>
      <tbody v-else class="tv-table-nodata">
        <tr>
          <td colspan="5">暂无数据!</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { extractDayTime } from '@/utils'

export default {
  name: 'DeviceAlarm',
  computed: {
    ...mapGetters(['cid']),
  },
  props: {
    span: {
      type: Number,
      default: 1,
    },
    title: {
      type: String,
      default: '设备报警信息',
    },
  },
  watch: {
    tableData(newData, oldData) {
      const newItem = newData.length && newData[0]
      const oldItem = oldData.length && oldData[0]
      if (!oldItem || newItem.SmartCareId !== oldItem.SmartCareId) {
        this.tableList = newData.map((item) => ({
          id: item.SmartCareId,
          time: extractDayTime(item.SmartCareAAlertTime),
          addr: item.SmartCareAAddress,
          name: item.ElderName,
          type: item.DeviceType,
          status: item.State,
        }))
        this.$nextTick(() => {
          !this.tableInterval && this.startAnimation()
        })
      }
    },
  },
  data() {
    return {
      barInterval: null,
      tableInterval: null,
      dataInterval: null,
      tableHead: ['时间', '地址', '姓名', '类型', '状态'],
      tableData: [],
      tableList: [],
    }
  },
  created() {
    this.getDeviceAlarmData(this.cid)
  },
  mounted() {
    this.dataInterval = setInterval(() => {
      this.getDeviceAlarmData(this.cid)
    }, this.$interval)
  },
  beforeDestroy() {
    if (this.tableInterval) {
      clearInterval(this.tableInterval)
      this.tableInterval = null
    }
    if (this.dataInterval) {
      clearInterval(this.dataInterval)
      this.dataInterval = null
    }
  },
  methods: {
    startAnimation() {
      const node = this.$refs.table
      if (node && node.childNodes.length > 1) {
        this.tableInterval = setInterval(() => {
          const newChild = node.firstChild.cloneNode(true)
          newChild.classList.add('animated', 'fadeInUp')
          node.appendChild(newChild)
          node.removeChild(node.firstChild)
        }, 3000)
      }
    },
    getDeviceAlarmData(id) {
      this.$api
        .getDeviceAlarmData(id, 5)
        .then((res) => {
          if (!res || !res.length) return
          this.tableData = res
        })
        .catch((err) => {
          console.error(err)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.tv-table {
  td {
    > img {
      display: inline-block;
      vertical-align: middle;
      width: 20px;
      height: auto;
    }

    > span {
      display: inline-block;
      vertical-align: middle;
      margin-left: 5px;
    }
  }

  .td-time {
    color: #fa7310;
  }

  .td-addr {
    width: 150px;
  }

  .td-name,
  .td-type {
    color: #fff;
  }

  .td-status {
    &--normal {
      color: #0ec560;
    }
    &--alarm {
      color: #f00033;
    }
  }
}
</style>
